export enum UserStatusEnum {
  ACTIVE = 'active',
  PENDING = 'pending',
  INACTIVE = 'inactive'
}
